import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'torchQuantity'
})
export class TorchQuantityPipe implements PipeTransform {

  transform(value: number | string | null, ...args: unknown[]): number {
    if (value === null || value === undefined || value === 0 || value === '0' || isNaN(Number(value))) {
      return 0
    } else if (!isNaN(Number(value))) {
      return Number(value)
    }
  }

}
